/*                                                                                                                     
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--'

Copyright (c) 2026 Dynamic IOT Data, Inc. All rights reserved.

@author Andrew Craig
*/
import { VisionApplication } from '../../application';
import { VisionLayout } from '../../layout';
import { VisionSecurityWindow } from '../../security/security.window';
import { VisionAssetWindow } from '../../window/asset';
import { VisionDeviceWindow } from '../../window/device';
import { VisionEventRulesWindow } from '../../window/event_rule';
import { VisionAssetFolderWindow } from '../../window/folder';
import { VisionGeofenceWindow } from '../../window/geofence.window';
import { VisionOrganizationWindow } from '../../window/organization';
import { VisionUserWindow } from '../../window/user.window';
import { AssetTree } from './asset_tree';
import { GeofenceTree } from './geofence';
import { MapPanel } from './map';
import { VisionGeofenceReportWindow } from './report_geofence_window';
//import { VisionRolesWindow } from '../../roleperm/window/role_window';
import { TrackingWindow } from './tracking';
import { TripWindow } from './trip.window';
import { WorkspaceWindow } from './workspace';

export class VisionAVLTab2 {
    // GUI Elements
    layout!: dhtmlXLayoutObject;
    menuRibbon: dhtmlXRibbon;
    tabbar: dhtmlXTabBar;

    // Vision Elements
    app: VisionApplication;
    assetTree: AssetTree;
    geofenceTree: GeofenceTree;
    mapPanel: MapPanel;

    //------------------------------
    // Windows.
    //------------------------------
    trackingWindow!: TrackingWindow | undefined;
    private tripWindow!: TripWindow | undefined;

    constructor(vision: VisionLayout) {
        this.app = vision.app;
        this.trackingWindow = undefined;

        const config: IdhtmlXLayoutConfig = {
            parent: document.body,
            pattern: '3T',
        };

        this.layout = vision.tabbar.cells('AVL2').attachLayout(config);

        this.layout
            .cells('a')
            .setText(
                '<svg fill="#FFFFFF" height="12px" width="12px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 150 150" xml:space="preserve"><g id="XMLID_240_"><path id="XMLID_241_" d="M15,30h120c8.284,0,15-6.716,15-15s-6.716-15-15-15H15C6.716,0,0,6.716,0,15S6.716,30,15,30z"/><path id="XMLID_242_" d="M135,60H15C6.716,60,0,66.716,0,75s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,60,135,60z"/><path id="XMLID_243_" d="M135,120H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,120,135,120z"/></g></svg>&nbsp;<b></b>'
            );
        this.layout
            .cells('a')
            .setCollapsedText(
                '<svg fill="#FFFFFF" height="12px" width="12px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 150 150" xml:space="preserve"><g id="XMLID_240_"><path id="XMLID_241_" d="M15,30h120c8.284,0,15-6.716,15-15s-6.716-15-15-15H15C6.716,0,0,6.716,0,15S6.716,30,15,30z"/><path id="XMLID_242_" d="M135,60H15C6.716,60,0,66.716,0,75s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,60,135,60z"/><path id="XMLID_243_" d="M135,120H15c-8.284,0-15,6.716-15,15s6.716,15,15,15h120c8.284,0,15-6.716,15-15S143.284,120,135,120z"/></g></svg>&nbsp;<b></b>'
            );
        this.layout.cells('a').collapse();
        this.layout.cells('a').fixSize(false, true);

        this.tabbar = this.layout.cells('b').attachTabbar();
        this.tabbar.addTab('ASSET', "<img src='icons/truck-pickup.png' style='vertical-align:middle; height=24'/>&nbsp;Assets", 100, 1, true, false);
        this.tabbar.addTab('GEOFENCE', " <img src='/css/imgs/rocking_tree/draw-polygon.png' style='vertical-align:middle; height=24'>&nbsp;Geofence", 130, 2, false, false);

        this.menuRibbon = this.layout.cells('a').attachRibbon({
            arrows_mode: 'auto',
            tabs: [
                {
                    id: 'admin',
                    text: 'Menu',
                    items: [
                        {
                            type: 'block',
                            text: "<img src='icons/admin-generic.png' style='float:left'>Admin",
                            text_pos: 'bottom',
                            mode: 'cols',
                            list: [
                                //1st block
                                { type: 'button', text: 'Devices', id: 'edit_device_window' },
                                { type: 'button', text: 'Assets', id: 'edit_asset_window' },
                                {
                                    type: 'button',
                                    text: 'Asset Grouping',
                                    id: 'edit_asset_folders',
                                },
                                { type: 'button', text: 'Users', id: 'edit_users_window' },
                                { type: 'button', text: 'Workspaces', id: 'edit_workspace' },
                                { type: 'button', text: 'Geofences', id: 'edit_geofence' },
                                { type: 'button', text: 'Roles', id: 'edit_roles' },
                                //{type:"button", text:"Event Rules", id:"edit_event_rules"}
                            ],
                        },
                    ],
                },
                {
                    id: 'report',
                    text: 'Reports',
                    items: [
                        {
                            type: 'block',
                            text: "<img src='icons/admin-generic.png' style='float:left'>Reports",
                            text_pos: 'bottom',
                            mode: 'cols',
                            list: [{ type: 'button', text: 'Geofence', id: 'geofence_report' }],
                        },
                    ],
                },
            ],
        });

        this.menuRibbon.tabs('admin').setActive();
        const rolesDisabled = !this.app.securityService.isAdmin;
        if (rolesDisabled) {
            this.menuRibbon.hide('edit_roles');
        }

        this.assetTree = new AssetTree(this);
        this.geofenceTree = new GeofenceTree(this);
        this.mapPanel = new MapPanel(this);
        this.events();
    }

    /** Get the trip window.
     *  If window does not exist it will create it.
     * @returns A window object.
     */
    public getTripWindow(): TripWindow {
        if (this.tripWindow == undefined) {
            this.tripWindow = new TripWindow(this.app.windowManager);
        }
        return this.tripWindow;
    }

    /** Get the tracking window.
     * If the window does not exist than it will create it.
     *
     * @returns
     */
    public getTrackingWindow(): TrackingWindow {
        if (this.trackingWindow == undefined) {
            this.trackingWindow = new TrackingWindow(this.app.windowManager);
        }
        return this.trackingWindow;
    }

    public getColumns(): (string | number)[] {
        const columns = [];
        const number = this.assetTree.tree.getColumnsNum();
        for (let i = 0; i < number; i++) {
            const col_id = this.assetTree.tree.getColumnId(i);
            const hidden = this.assetTree.tree.isColumnHidden(i);
            if (hidden == false) {
                columns.push(col_id);
            }
        }
        return columns;
    }

    private events(): void {
        this.layout.attachEvent('onDblClick', (name) => {
            if (name == 'd' || name == 'a') {
                if (this.layout.cells(name).isCollapsed()) {
                    this.layout.cells(name).expand();
                    if (name == 'a') {
                        this.layout.cells('a').setHeight(200);
                    } else if (name == 'd') {
                        this.layout.cells('d').setHeight(400);
                    }
                } else {
                    this.layout.cells(name).collapse();
                }
            }
            return false;
        });

        this.menuRibbon.attachEvent('onClick', (id) => {
            let window = null;

            switch (id) {
                case 'edit_device_window':
                    window = new VisionDeviceWindow(this.app.windowManager);
                    break;
                case 'edit_asset_folders':
                    window = new VisionAssetFolderWindow(this.app.windowManager);
                    break;
                case 'edit_organization_window':
                    window = new VisionOrganizationWindow(this.app.windowManager);
                    break;
                case 'edit_asset_window':
                    window = new VisionAssetWindow(this.app.windowManager);
                    break;
                case 'edit_geofence_window':
                    window = new VisionGeofenceWindow(this.app.windowManager);
                    break;
                case 'edit_users_window':
                    window = new VisionUserWindow(this.app.windowManager);
                    break;
                case 'edit_workspace':
                    window = new WorkspaceWindow(this.app.windowManager);
                    break;
                case 'edit_geofence':
                    window = new VisionGeofenceWindow(this.app.windowManager);
                    break;
                case 'edit_event_rules':
                    window = new VisionEventRulesWindow(this.app.windowManager);
                    break;
                case 'geofence_report':
                    window = new VisionGeofenceReportWindow(this.app.windowManager);
                    break;
                case 'edit_roles':
                    //window = new VisionRolesWindow(this.app.windowManager);
                    window = new VisionSecurityWindow(this.app.windowManager);
                    console.log('Edit Roles Window');
                    break;
            }
            window?.show();
        });
    }
}
